<template>
  <div class="home body">
    <!-- <el-container>
      <el-aside >
        <div class="sidebar">
          <div class="side">
           
          </div>
       
        </div>
      </el-aside>
      <el-main>
        <el-tabs v-model="activeName">
          <el-tab-pane label="يومية الفرع" name="second">
            
            <el-row :gutter="20" class="mt-4">
              <el-col :span="8" v-for="(item, index) in data" :key="index"
                ><div class="bg-white" data-aos="fade-up">
                  <div class="content">
                    <p class="num">{{ item.number }}</p>
                    <p class="text">{{ item.text }}</p>
                  </div>
                </div></el-col
              >
            </el-row></el-tab-pane
          >
          <el-tab-pane label="يومية الكاشير" name="first">
            
            <el-row :gutter="20" class="mt-4">
              <el-col :span="8" v-for="(item, index) in data" :key="index"
                ><div class="bg-white" data-aos="fade-up">
                  <div class="content">
                    <p class="num">{{ item.number }}</p>
                    <p class="text">{{ item.text }}</p>
                  </div>
                </div></el-col
              >
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container> -->
  </div>
</template>

<script>
export default {
  name: "Home",
  created() {
    this.$router.push("/projects");
  },
  data: () => ({
    activeName: "first",
    data: [
      {
        number: 124.971,
        text: "المرتجعات",
      },

      {
        number: 0.0,
        text: "المبيعات الأجلة",
      },
      {
        number: 1.029,
        text: "المصروفات لليوم",
      },
      {
        number: 7.608,
        text: "مبيعات الكاش",
      },
      {
        number: 124.971,
        text: "المرتجعات",
      },

      {
        number: 124.971,
        text: "المرتجعات",
      },
      {
        number: 124.971,
        text: "المرتجعات",
      },
      {
        number: 124.971,
        text: "المرتجعات",
      },
    ],
  }),
  methods: {},
};
</script>
<style lang="sass" >
@import "../styles/home.scss"
</style>
